import { ClaimableBenefit } from 'components/Benefits/Benefits.types'
import IMyCollectionFacade, {
  BalancesOfType,
  FacadeTypes,
} from 'service/IMyCollectionFacade'
import { functions } from 'core/modules/firebase'
import { i18n } from 'translate/i18n'
import Web3 from 'web3'
import { ContractType } from 'core/logic/contract/types/types'

export default abstract class ERC721AbstractFacade<
  C extends Contract.DigitalTwin | Contract.ERC721
> extends IMyCollectionFacade {
  nftContractForRead!: C

  abstract getContractInstance(): C
  constructor(
    nftContractAddress: string,
    web3ForRead: Web3,
    web3ForWrite: Web3
  ) {
    super(nftContractAddress, FacadeTypes.BENEFITS, web3ForRead, web3ForWrite)

    this.nftContractForRead = this.getContractInstance()
  }
  async claimBenefit(benefit: ClaimableBenefit) {
    await functions.httpsCallable('assets-redeem')({
      tenantId: process.env.REACT_APP_TENANT_IDENTITY_ID,
      assetId: benefit.assetId,
      benefit: benefit.code,
      amount: 1,
      tokenId: String(benefit.tokenId),
      language: i18n.language,
    })
  }
  async getOwnedItems(): Promise<BalancesOfType<ContractType.Loyalty>[]> {
    const nftBalancesByWallet = await Promise.all(
      this.wallets.map((wallet) =>
        this.nftContractForRead.methods.balancesOf(wallet).call()
      )
    )
    const CIDsToConsider: Set<string> = new Set()
    const balanceMap: { [cid: string]: string[] } = {}
    const tiersCIDs =
      'tierList' in this.nftContractForRead.methods
        ? await this.nftContractForRead.methods.tierList().call()
        : null

    for (let nftBalances of nftBalancesByWallet) {
      Object.assign(
        balanceMap,
        nftBalances.tokenIds.reduce((r, tokenId, index) => {
          const tierId =
            'tiers' in nftBalances
              ? nftBalances.tiers[index]
              : nftBalances.uris[index]
          const tierCID = tiersCIDs ? tiersCIDs[Number(tierId)] : tierId
          const currentTokens = r[tierCID] || []
          return {
            ...r,
            [tierCID]: [...currentTokens, tokenId],
          }
        }, {} as { [cid: string]: string[] })
      )
      for (let cid of Object.keys(balanceMap)) CIDsToConsider.add(cid)
    }
    const CIDs = Array.from(CIDsToConsider)

    return CIDs.reduce(
      (r, a) => [
        ...r,
        ...balanceMap[a].map(
          (tokenId) =>
            ({
              type: ContractType.Loyalty,
              balance: 1,
              cid: a,
              tokenId: Number(tokenId),
            } as BalancesOfType<ContractType.Loyalty>)
        ),
      ],
      [] as BalancesOfType<ContractType.Loyalty>[]
    )
  }
}
